import { Auth } from './auth.js';
import * as Logger from './logger.js';

// Singleton client for the pipeline-sandbox help system
// (docs/PIPELINE_SANDBOX_HELP_SYSTEM.md §4/§8). Fetches the whole registry
// once per base URL and caches it in memory for the page session.
class HelpRegistryClass {
    #baseUrl = null;
    #items = {};
    #loaded = false;
    #loading = null;

    configure(baseUrl) {
        const next = baseUrl || '/elm/api';
        if (next !== this.#baseUrl) {
            this.#baseUrl = next;
            this.#items = {};
            this.#loaded = false;
            this.#loading = null;
        }
    }

    async ensureLoaded() {
        if (this.#loaded) return;
        if (!this.#loading) this.#loading = this.#fetch();
        try {
            await this.#loading;
        } finally {
            this.#loading = null;
        }
    }

    async #fetch() {
        try {
            const res = await Auth.fetch({ path: `${this.#baseUrl || '/elm/api'}/help` });
            this.#items = res?.items || {};
        } catch (err) {
            // Absent registry just means every help icon stays hidden — not fatal.
            Logger.debug('Help registry fetch failed: ', err);
            this.#items = {};
        }
        this.#loaded = true;
    }

    getEntry(key) {
        return (key && this.#items[key]) || null;
    }

    // Generic prefix lookup — used by the concept index panel for
    // `concept.*`, but not concept-specific itself. Sorted for a stable
    // alphabetical listing.
    getEntriesByPrefix(prefix) {
        return Object.keys(this.#items)
            .filter(k => k.startsWith(prefix))
            .map(k => ({ key: k, entry: this.#items[k] }))
            .sort((a, b) => a.key.localeCompare(b.key));
    }
}

export const HelpRegistry = new HelpRegistryClass();
